
import { defineComponent, reactive, ref } from 'vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'
import InputTime from '@/components/inputs/InputTime.vue'

import { store } from '@/store'
import { RouteSettings } from '@/api/tripply/models'
import { compareObjects } from '@/api/tools'

export default defineComponent({
  name: 'RouteSettings',
  components: { InputSelectHorizontal, InputTime },
  props: {
    route: {
      type: Object,
      required: true    
    }
  },
  setup(props) {
    const saving = ref(false)    
    const settings = reactive<RouteSettings>({ ...props.route.settings })
    settings.breakTime /= 60
    settings.timeLimit /= 3600

    const breaks = ref(
      settings.timeLimit > 0 ? 'auto' :
        settings.breakTime > 0 ? 'fixed' :
          'none'
    )

    async function save() {
      saving.value = true
      const updatedSettings = {...settings}
      updatedSettings.breakTime *= 60
      updatedSettings.timeLimit *= 3600
      if (breaks.value == 'fixed') updatedSettings.timeLimit = 0
      if (breaks.value == 'none') {
        updatedSettings.timeLimit = 0
        updatedSettings.breakTime = 0
      } 
      store.route.updateSettings(props.route.id, compareObjects<RouteSettings>(props.route.settings, updatedSettings))
      saving.value = false
      store.modal.hideModal('RouteSettings')
    }

    return { settings, saving, save, breaks }
  }
})
